var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGender = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0165 17.0271L6.92092 26.652H13.6185V37.0079H11.3571V28.9134H3.16504L10.0179 15.969L12.0165 17.0271ZM24.8933 37.0079V28.0635L19.0504 17.0271L21.049 15.969L27.1546 27.5019V37.0079H24.8933ZM32.5691 28.0635V37.0079H30.3077V27.5019L36.4133 15.969L38.4119 17.0271L32.5691 28.0635ZM29.4083 11.0587C31.0116 11.0587 32.3113 9.75893 32.3113 8.15562C32.3113 6.5523 31.0116 5.25256 29.4083 5.25256C27.805 5.25256 26.5052 6.5523 26.5052 8.15562C26.5052 9.75893 27.805 11.0587 29.4083 11.0587ZM34.5727 8.15562C34.5727 11.0078 32.2605 13.32 29.4083 13.32C26.5561 13.32 24.2439 11.0078 24.2439 8.15562C24.2439 5.30339 26.5561 2.99121 29.4083 2.99121C32.2605 2.99121 34.5727 5.30339 34.5727 8.15562ZM16.7715 37.0079V26.6791H19.0329V37.0079H16.7715ZM14.5188 11.0587C16.1222 11.0587 17.4219 9.75893 17.4219 8.15562C17.4219 6.5523 16.1222 5.25256 14.5188 5.25256C12.9155 5.25256 11.6158 6.5523 11.6158 8.15562C11.6158 9.75893 12.9155 11.0587 14.5188 11.0587ZM19.6833 8.15562C19.6833 11.0078 17.3711 13.32 14.5188 13.32C11.6666 13.32 9.35444 11.0078 9.35444 8.15562C9.35444 5.30339 11.6666 2.99121 14.5188 2.99121C17.3711 2.99121 19.6833 5.30339 19.6833 8.15562Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGender);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gender.565b8dac717f6673d6df642dd548c472.svg";